import { ErrorKey } from './ErrorKey';
import StandardError from './StandardError';
import { jsx as _jsx } from "react/jsx-runtime";
const PartnerExistingAccountErrorView = () => {
  return /*#__PURE__*/_jsx(StandardError, {
    errorKey: ErrorKey.PartnerExistingAccountError
  });
};
export default PartnerExistingAccountErrorView;